import { ASSIGN_INSTALLERS_SUCCESS, ASSIGN_INSTALLERS_FAILURE } from '../../actions/project_ticket_actions'

export default function reducer(state, action) {
  switch (action.type) {
    case ASSIGN_INSTALLERS_SUCCESS:
      return {
        ...state,
        errors: [],
        ready_to_reload_page: true
      }
    case ASSIGN_INSTALLERS_FAILURE:
      return {
        ...state,
        errors: action.error.response.data['errors'] || action.error.message,
        ready_to_reload_page: true
      }
  }
  return state
}
